import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { FaviconService } from '../favicon.service';
import { LoginService } from '../security/login.service';
import { ActivatedRoute } from '@angular/router';
import { UserForBackend } from '../user-for-backend';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { Role } from '../role';
import { ROLES } from '../roles';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-system-user-edit',
  templateUrl: './system-user-edit.component.html',
  styleUrls: ['./system-user-edit.component.css']
})
export class SystemUserEditComponent implements OnInit {

  selectedUser!: UserForBackend;
  userForm!: FormGroup;
  editPassword = false;
  roles: string[] = ROLES;
  hidingPassword = true;
  receiveVademecum = false;

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute,
    private favicon: FaviconService,
    private loginService: LoginService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();

    let promotionId = parseInt(this.route.snapshot.paramMap.get("userId")!);
    this.httpService.getSystemUserById(promotionId).subscribe(user => {
      this.selectedUser = user;
      this.userForm = this.builder.group({
        username: [this.selectedUser.name, Validators.required],
        password: ["", Validators.pattern(new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})"))],
        email: [this.selectedUser.email, Validators.required],
        slackId: this.selectedUser.slackId,
        roles: this.builder.array([]),
        receiveVademecum: false,
        receiveMailForBookingsWithoutVademecum: false,
        canSeeArchivedQuotationTemplates: false
      });
      this.setRoles();
    });
  }

  ngOnInit() {

  }

  setRoles(){
    for(let role of this.roles){
      let selected = false;
      for(let role2 of this.selectedUser.roles){
        if(role == role2){
          selected = true;
        }
      }
      (this.userForm.controls["roles"] as FormArray).push(new FormControl(selected));
    }
    for(let userRole of this.selectedUser.roles){
      if(userRole == "vademecum_receiver"){
        this.userForm.get("receiveVademecum")!.setValue(true);
      }
      if(userRole == "vademecum_notification_receiver"){
        this.userForm.get("receiveMailForBookingsWithoutVademecum")!.setValue(true);
      }
      if(userRole == "archived_quotation_template_viewer"){
        this.userForm.get("canSeeArchivedQuotationTemplates")!.setValue(true);
      }
    }
  }

  modifyPassword() {
    this.editPassword = true;
  }
  cancelModifyPassword() {
    this.editPassword = false;
    this.userForm.get("password")!.setValue("");
    this.hidingPassword = true;
  }

  sendForm(){
    this.selectedUser.name = this.userForm.value.username;
    this.selectedUser.password = this.userForm.value.password;
    this.selectedUser.slackId = this.userForm.value.slackId;
    this.selectedUser.roles = this.getCheckedRoles();
    this.httpService.putSystemUser(this.selectedUser).subscribe(() => {
      console.log("success");
      this.toastService.addSuccess("Success", "Updated successfully");
    }, error => {
      this.toastService.addError("Error", error.message);
    });
  }

  getCheckedRoles(): string[]{
    let newRoles: string[] = [];
    for(let j = 0; j < (this.userForm.controls["roles"] as FormArray).length; j++){
      if((this.userForm.controls["roles"] as FormArray).controls[j].value == true){
        newRoles.push(this.roles[j]);
      }
    }
    if(this.userForm.value.receiveVademecum){
      newRoles.push("vademecum_receiver");
    }
    if(this.userForm.value.receiveMailForBookingsWithoutVademecum){
      newRoles.push("vademecum_notification_receiver");
    }
    if(this.userForm.value.canSeeArchivedQuotationTemplates){
      newRoles.push("archived_quotation_template_viewer");
    }
    return newRoles;
  }

  showPassword(){
    this.hidingPassword = false;
  }
  hidePassword(){
    this.hidingPassword = true;
  }

}
